import {
  Component,
} from '@angular/core';

@Component({
  selector: 'fgb-predictor-layout-page',
  templateUrl: './predictor-layout-page.component.html',
  styleUrl: './predictor-layout-page.component.scss',
})
export class PredictorLayoutPageComponent {
  
}
